// @core/api/endpoints/notifications/get_contact_by_value.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  ContactResponse,
} from '../../../types/notifications';

const BASE_PATH = '/notifications';

/**
 * Get contact by value
 * Looks up a contact by its actual value such as email address or phone number. Returns the contact if found or null if not registered.
 */
export async function GetContactByValue(
  params?: {
  },
  options?: RequestOptions
): Promise<ContactResponse> {
  const client = getApiClient();
  const requestPath = `${BASE_PATH}/contacts/by-value`;
  const requestOptions = options;
  return client.get<ContactResponse>(requestPath, { ...requestOptions, params });
}
